module.exports = [
  { cost: 0, price: 0 },
  { cost: 485000, price: 530000 },
  { cost: 485000, price: 530000 },
  { cost: 485000, price: 530000 },
  { cost: 485000, price: 530000 },
  { cost: 485000, price: 530000 },
  { cost: 485000, price: 530000 },
  { cost: 485000, price: 530000 },
  { cost: 485000, price: 530000 },
]
